import { TrendingUp, Sparkles } from "lucide-react";

const fmtEUR = (v) =>
  new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v || 0);

const ForecastCard = ({ horizon }) => (
  <div className="bg-[#FCFAF8] border border-[#0A1128]/10 p-6 flex flex-col gap-4">
    <div className="flex items-center justify-between">
      <div>
        <div className="overline text-[#C5A059]">Previsão · {horizon.months} meses</div>
        <h4 className="font-serif-display text-2xl text-[#0A1128] mt-1">
          {fmtEUR(horizon.net_total)} <span className="text-base text-[#3A435E]">líquido</span>
        </h4>
      </div>
      <TrendingUp size={20} className="text-[#C5A059]" strokeWidth={1.3} />
    </div>

    <div className="grid grid-cols-2 gap-3 text-xs">
      <div className="border-l-2 border-[#C5A059]/40 pl-3">
        <div className="text-[#7B86A4] text-[10px] tracking-[0.18em] uppercase">Já confirmado</div>
        <div className="text-[#0A1128] mt-0.5 font-medium">{fmtEUR(horizon.confirmed_gross)}</div>
      </div>
      <div className="border-l-2 border-[#0A1128]/20 pl-3">
        <div className="text-[#7B86A4] text-[10px] tracking-[0.18em] uppercase">Estimado</div>
        <div className="text-[#0A1128] mt-0.5 font-medium">{fmtEUR(horizon.estimated_extra_gross)}</div>
      </div>
      <div className="border-l-2 border-[#0A1128]/20 pl-3">
        <div className="text-[#7B86A4] text-[10px] tracking-[0.18em] uppercase">Dias livres</div>
        <div className="text-[#0A1128] mt-0.5 font-medium">{horizon.free_days} / {horizon.total_days}</div>
      </div>
      <div className="border-l-2 border-[#0A1128]/20 pl-3">
        <div className="text-[#7B86A4] text-[10px] tracking-[0.18em] uppercase">Ocupação base</div>
        <div className="text-[#0A1128] mt-0.5 font-medium">{horizon.occupancy_rate}%</div>
      </div>
    </div>
  </div>
);

const ForecastPanel = ({ data }) => {
  const horizons = data?.horizons || [];
  if (horizons.length === 0) return null;
  return (
    <section className="bg-[#F4F1EB]/40 border border-[#0A1128]/10 p-6 md:p-8" data-testid="forecast-panel">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles size={14} className="text-[#C5A059]" strokeWidth={1.4} />
        <span className="overline">Estimativa inteligente</span>
      </div>
      <h3 className="font-serif-display text-2xl md:text-3xl text-[#0A1128] font-light">
        Rendimento esperado nos próximos meses
      </h3>
      <p className="text-sm text-[#3A435E] mt-2 max-w-3xl">
        Combina <strong className="text-[#0A1128]">reservas já confirmadas</strong> com uma estimativa nas datas ainda livres,
        baseada na taxa de ocupação histórica e na sua tarifa média.
        Valor líquido inclui dedução da comissão de gestão (15%).
      </p>
      <div className="grid md:grid-cols-2 gap-4 mt-6">
        {horizons.map((h) => (<ForecastCard key={h.months} horizon={h} />))}
      </div>
    </section>
  );
};

export default ForecastPanel;
